import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { createItem, fetchCreateItemModal } from "../HTTPRequests/ItemRequests";
import Mediator from "../Utilities/Mediator";
import ItemBaseModal from "./ItemBaseModal";

export default class CreateItemModal extends ItemBaseModal {
	modalDiv: HTMLDivElement;
	createButton: HTMLButtonElement;

	constructor(createStoreButton: HTMLButtonElement) {
		super();
		this.modalDiv = document.createElement('div');
		this.createButton = createStoreButton;
	}

	public addCreateModalClickListener() {
		this.createButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchModal();
		}
	}

	private fetchModal() {
		fetchCreateItemModal()
			.then((response: string) => {
				this.openModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);

		this.addSubItemsModalEventsListeners(this.modalDiv);
		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners();
	}

	private addModalButtonsClickListeners() {
		const cancelButton: HTMLButtonElement = this.modalDiv.querySelector('button');
		const img: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('button + button');

		cancelButton.onclick = () => {
			this.modalDiv.remove();
		}

		img.onclick = () => {
			this.modalDiv.remove();
		}

		saveButton.onclick = () => {
			this.saveCreatedItem();
		}
	}

	private saveCreatedItem() {
		let { valid, itemFormData } = this.ModalData;
		if (valid) {
			document.body.append(this.loadingScreen);
			itemFormData.append("displayOrder", this.form.dataset.displayOrder);
			this.createItem(itemFormData);
		} else {
			this.form.reportValidity();
		}
	}

	private createItem(itemFormData: FormData) {
		createItem(itemFormData)
			.then(() => {
				this.openSuccessModal();
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
				Mediator.emit("itemCrudOperationFinished");
			});
	}

	private openSuccessModal() {
		const warningModal: HTMLDivElement = this.modalDiv.querySelector('#warning-item-modal');
		warningModal.style.display = "flex";

		this.addSuccessModalClickListeners(warningModal);
	}

	private addSuccessModalClickListeners(warningModal: HTMLDivElement) {
		const closeImg: HTMLImageElement = warningModal.querySelector('img[alt="close icon"]');
		const cancelButton: HTMLButtonElement = warningModal.querySelector('button');
		const okButton: HTMLButtonElement = warningModal.querySelector('button + button');

		window.onclick = (event: MouseEvent) => {
			if (event.target === warningModal) {
				warningModal.style.display = "none";
				this.modalDiv.remove();
			}
		}

		cancelButton.onclick = () => {
			warningModal.style.display = "none";
			this.modalDiv.remove();
		}

		closeImg.onclick = () => {
			warningModal.style.display = "none";
			this.modalDiv.remove();
		}

		okButton.onclick = () => {
			const sortIcon: HTMLElement = document.querySelector('h1.text-header i');
			const click: Event = new Event("click");
			warningModal.style.display = "none";
			this.modalDiv.remove();
			sortIcon.dispatchEvent(click);
		}
	}
}
